<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
>

<section class="hero-phone-section">
  <div class="hero-phone">
    <i class="pi pi-phone"></i>
    <a href="tel:0143271243">01 43 27 12 43</a>
  </div>
</section>

<section class="contact-info-section">
  <div class="container">
    <div class="info-intro">
      <p>
        Si vous avez une question ou une demande particulière à propos de Brokins, envoyez simplement un email à 
        <a href="mailto:contact@brokins.fr" class="email-link">contact&#64;brokins.fr</a>
        ou prenez directement un 
        <a href="javascript:void(0)" class="rdv-link" (click)="openAppointmentPicker()">RDV Téléphonique en cliquant ici</a>, 
        et nous vous répondrons très rapidement.
      </p>
    </div>

    <h2 class="section-title">Nos bureaux</h2>

    <div class="offices-grid">
      <div class="office-card">
        <div class="office-header">
          <i class="pi pi-map-marker"></i>
          <h3>Notre siège social à Paris</h3>
        </div>
        <div class="office-content">
          <p class="office-address">
            <strong>Adresse</strong><br>
            79 rue de Rennes<br>
            75006, Paris<br>
            01 43 27 12 43
          </p>
        </div>
      </div>

      <div class="office-card">
        <div class="office-header">
          <i class="pi pi-map-marker"></i>
          <h3>Nos bureaux à Paris</h3>
        </div>
        <div class="office-content">
          <p class="office-address">
            <strong>Adresse</strong><br>
            Uniquement sur RDV<br>
            160 bis rue de Rennes<br>
            75006, Paris<br>
            01 43 27 12 43
          </p>
        </div>
      </div>

      <div class="office-card">
        <div class="office-header">
          <i class="pi pi-phone"></i>
          <h3>Contacts conseillers</h3>
        </div>
        <div class="office-content">
          <p class="contact-list">
            <strong>Téléphone</strong><br>
            Assurance Emprunteur : 0781810093<br>
            Assurance Santé : 0782281116<br>
            Assurance Professionnelle & Entreprise : 0142371243<br>
            Assurance RC : 0142271243<br>
            Assurance Décennale : 0142271243<br>
            Assurance Dommage Ouvrage : 0142271243
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="rdv-section">
  <div class="container">
    <div class="rdv-content">
      <h2>Prenez rendez-vous avec nos conseillers experts</h2>
      <div class="booking-card">
        <div class="booking-icon">📅</div>
        <h3 class="booking-title">Consultation Gratuite</h3>
        <p class="booking-subtitle">Discutez avec un expert en assurance</p>
        <div class="booking-details">
          <div class="detail-item">
            <i class="pi pi-clock"></i>
            <span>Durée: 30 minutes</span>
          </div>
          <div class="detail-item">
            <i class="pi pi-video"></i>
            <span>Par téléphone ou visioconférence</span>
          </div>
          <div class="detail-item">
            <i class="pi pi-calendar"></i>
            <span>Disponible du lundi au vendredi</span>
          </div>
        </div>
        <button class="btn-book" (click)="openAppointmentPicker()">
          <i class="pi pi-calendar-plus"></i>
          Réserver un créneau
        </button>
      </div>
    </div>
  </div>
</section>

</app-page-layout>
